import { createAPI } from "./apisServer";

const apiServer = createAPI("webhook");

const reqStatusWebhook = {
	status: async function () {
		return apiServer
			.get("webhook/ping")
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqStatusWebhook;
